"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMAIL_REGEX = exports.NAME_REGEX = exports.FORMAT_STRING_TIME_24 = exports.FORMAT_STRING_TIME_12 = void 0;
exports.FORMAT_STRING_TIME_12 = "h:mm A";
exports.FORMAT_STRING_TIME_24 = "H:mm";
exports.NAME_REGEX = /^[a-z ,.'-]+$/i;
exports.EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;